import FlatMultiSelect from "./FlatMultiSelect";

export default FlatMultiSelect;
